import { useSearchParams } from "react-router-dom";
import CommandLauncherComponent from "./CommandLauncherComponent";
import CommandIdEnum from "../../enums/CommandIdEnums";

interface FocusOnBimObjectComponentProps {
    urlParamName: string;
}

const FocusOnBimObjectComponent = ({ urlParamName }: FocusOnBimObjectComponentProps) => {
    const [searchParams] = useSearchParams();
    const globalId = searchParams.get(urlParamName);

    if (!globalId) return null;

    return (
        <CommandLauncherComponent
            commands={[{ commandId: CommandIdEnum.FocusOnBimObject, parameters: globalId }]}
        />
    );
};

export default FocusOnBimObjectComponent;
